module.exports = __webpack_public_path__ + "assets/img/官网首页-en.e5481584.jpg";